import React from 'react';
import { NotFound } from '@noths/polaris-client-next-components';

import * as styles from './PageErrorMessage.styles';

const GENERAL_MESSAGE = "Oops, Something's gone wrong.";

interface PageErrorMessageProps {
  pageNotFound?: boolean;
}

export const PageErrorMessage = ({ pageNotFound = false }: PageErrorMessageProps) => {
  return (
    <div css={styles.errorGuard}>
      {pageNotFound ? <NotFound /> : <h1 css={styles.heading}>{GENERAL_MESSAGE}</h1>}
    </div>
  );
};
